var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "root" }, [
    _c("div", { staticClass: "title" }, [
      _c(
        "div",
        {
          on: {
            click: function($event) {
              return _vm.$router.push({
                name: "device",
                query: { iccid: _vm.imei }
              })
            }
          }
        },
        [_vm._v("联网模式")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "active" }, [_vm._v("本地模式")])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "box-1" }, [
      _c("div", [
        _c("img", {
          attrs: { src: require("../assets/images/lianjie_03.png") }
        }),
        _vm._v(" "),
        _c("span", [_vm._v("设备连接 " + _vm._s(_vm.deviceInfo.client_number))])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("img", {
          attrs: { src: require("../assets/images/zaixian_03.png") }
        }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.online == 1 ? "在线" : "离线"))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "box-2" }, [
      _c("div", { staticClass: "box-title" }, [_vm._v("设备设置")]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "input-control" }, [
          _c("div", { staticClass: "label" }, [_vm._v("WiFi名称：")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.editSsid.ssid,
                expression: "editSsid.ssid"
              }
            ],
            attrs: { placeholder: _vm.deviceInfo.ssid },
            domProps: { value: _vm.editSsid.ssid },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.editSsid, "ssid", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-control" }, [
          _c("div", { staticClass: "label" }, [_vm._v("WiFi密码：")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.editSsid.key,
                expression: "editSsid.key"
              }
            ],
            attrs: { placeholder: _vm.deviceInfo.password },
            domProps: { value: _vm.editSsid.key },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.editSsid, "key", $event.target.value)
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "addon", on: { click: _vm.saveSsid } }, [
            _vm._v("保存")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-control" }, [
          _c("div", { staticClass: "label" }, [_vm._v("设备重启")]),
          _vm._v(" "),
          _c("div", { staticClass: "addon", on: { click: _vm.restart } }, [
            _vm._v("重启")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-control" }, [
          _c("div", { staticClass: "label" }, [_vm._v("设备恢复出厂设置")]),
          _vm._v(" "),
          _c("div", { staticClass: "addon", on: { click: _vm.reset } }, [
            _vm._v("重置")
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "box-2" }, [
      _c("div", { staticClass: "box-title" }, [_vm._v("网络切换")]),
      _vm._v(" "),
      _c("div", { staticClass: "content flex" }, [
        _c(
          "div",
          {
            staticClass: "net-check",
            class: _vm.deviceInfo.current_sim_id == 0 ? "active" : "",
            on: {
              click: function($event) {
                return _vm.qieka(0)
              }
            }
          },
          [
            _vm.deviceInfo.current_sim_id == 0
              ? _c("img", {
                  attrs: { src: require("../assets/newimg/dianxin_active.png") }
                })
              : _c("img", {
                  attrs: { src: require("../assets/newimg/dianxin.png") }
                }),
            _vm._v(" "),
            _c("div", [_vm._v("中国电信")]),
            _vm._v(" "),
            _c("img", {
              staticClass: "tag",
              attrs: { src: require("../assets/newimg/xuanzhong.png") }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "net-check",
            class: _vm.deviceInfo.current_sim_id == 1 ? "active" : "",
            on: {
              click: function($event) {
                return _vm.qieka(1)
              }
            }
          },
          [
            _vm.deviceInfo.current_sim_id == 1
              ? _c("img", {
                  attrs: {
                    src: require("../assets/newimg/liantong_active.png")
                  }
                })
              : _c("img", {
                  attrs: { src: require("../assets/newimg/liantong.png") }
                }),
            _vm._v(" "),
            _c("div", [_vm._v("中国联通")]),
            _vm._v(" "),
            _c("img", {
              staticClass: "tag",
              attrs: { src: require("../assets/newimg/xuanzhong.png") }
            })
          ]
        ),
        _vm._v(" "),
        _vm.deviceInfo.sim_list && _vm.deviceInfo.sim_list[2]
          ? _c(
              "div",
              {
                staticClass: "net-check",
                class: _vm.deviceInfo.current_sim_id == 2 ? "active" : "",
                on: {
                  click: function($event) {
                    return _vm.qieka(2)
                  }
                }
              },
              [
                _vm.deviceInfo.current_sim_id == 2
                  ? _c("img", {
                      attrs: {
                        src: require("../assets/newimg/yidong_active.png")
                      }
                    })
                  : _c("img", {
                      attrs: { src: require("../assets/newimg/yidong.png") }
                    }),
                _vm._v(" "),
                _c("div", [_vm._v("中国移动")]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "tag",
                  attrs: { src: require("../assets/newimg/xuanzhong.png") }
                })
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "net-check one",
            on: {
              click: function($event) {
                return _vm.qieka(99)
              }
            }
          },
          [_c("div", [_vm._v("智能选网")])]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "box-2" }, [
      _c("div", { staticClass: "box-title" }, [_vm._v("设备信息")]),
      _vm._v(" "),
      _c("div", { staticClass: "content noborder" }, [
        _c("div", { staticClass: "input-control" }, [
          _c("div", { staticClass: "label" }, [_vm._v("卡号：")]),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [
            _vm._v(
              "\n           " + _vm._s(_vm.deviceInfo.iccid) + "\n          "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-control" }, [
          _c("div", { staticClass: "label" }, [_vm._v("信号强度：")]),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.deviceInfo.rsrp) + "dbm 良好")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-control" }, [
          _c("div", { staticClass: "label" }, [_vm._v("IMEI码：")]),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.deviceInfo.imei))
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f2c6c4fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ../app/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2c6c4fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../app/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/devicelocal.vue
// module id = null
// module chunks = 